import { app } from '../../../../app';

app.factory('CompanyApplicationOverviewService', CompanyApplicationOverviewService);

/** @ngInject */
function CompanyApplicationOverviewService($http, $resource) {
    var rootUrl = 'app/rest/admin/company/:companyId/application/:appId/manageapp/overview';

    return {
        drawChart: $resource(rootUrl + '/drawChart'),
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/integration-developers/company-application-overview.service.js